const MAPS_API_KEY = "AIzaSyBEXQ990KC3e-1GklhfLENNavc40uRLvKk"; //
// "AIzaSyBEXQ990KC3e-1GklhfLENNavc40uRLvKk"; production key
// "AIzaSyAut8wMgiwUlNdnp0BGlpbG4Jc0umurpM0"; development key

export default MAPS_API_KEY;
